<template>
  <div :class="['cityBlock__container', {cityBlock__header: this.header}]">
    <div class="ms-pill">
      <q-icon name="fa-solid fa-location-dot" class="ms-pill__icon" />
      <span class="ms-pill__label">{{ this.userData?.city_name || '-' }}</span>
      <q-icon name="fa-solid fa-chevron-down" class="ms-pill__chevron" />
      <q-tooltip anchor="bottom middle" self="top middle" :delay="400">Выберите город</q-tooltip>
    </div>
    <q-menu anchor="bottom left" self="top left" :offset="[0, 6]" class="ms-dropdown">
      <q-list style="min-width: 160px">
        <q-item
          v-for="item in this.cities"
          :key="item.city_id"
          clickable
          v-close-popup
          :active="item.city_id === this.userData?.city_id"
          @click="this.handleChangeCity(item.city_id)"
        >
          <q-item-section>{{item.city_name}}</q-item-section>
        </q-item>
      </q-list>
    </q-menu>
  </div>
</template>

<script>
import {appActionTypes} from "@/services/store/modules/app_module/app_mutation_types";

export default {
  name: "CityBlock",
  props: {
    header: Boolean
  },
  computed: {
    userData() {
      return this.$store.state.app?.userData
    },
    cities() {
      return this.$store.state.app?.cities
    },
  },
  methods: {
    async handleChangeCity(city_id) {
      this.$store.dispatch(appActionTypes.chooseCity, city_id)
    },
  }
}
</script>

<style scoped lang="scss">
// Вид — общая пилюля .ms-pill (assets/styles/theme.scss).
// В хедере блок виден от 577px, на телефоне — в шапке бокового меню.
.cityBlock {
  &__container {
    display: none;
    min-width: 0;
    @media (max-width: 576px) {
      display: flex;
    }
  }

  &__header {
    display: flex;
    @media (max-width: 576px) {
      display: none;
    }
  }
}
</style>
